import { render } from "./HomeView.vue?vue&type=template&id=656a90de&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import "./HomeView.vue?vue&type=style&index=0&id=656a90de&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Antonio\\Desktop\\model-viewer-generator_fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-656a90de"]])

export default __exports__